import Forward from "@/views/Forward.vue";

export default (rootPath) => {
  return [
    {
      path: "",
      component: Forward,
      redirect: `${rootPath}/list`,
      hidden: true,
      children: [
        {
          path: "list",
          component: () => import("@/views/table/AuditTable.vue"),
          meta: { title: "История аудита", activeMenuParent: true },
          hidden: true,
        },
      ],
    },
  ];
};
